<template>
  <div class="content" ref="content">
    <template v-for="block in content">
      <template v-if="block.type == 'heading'">
        <h1
          :key="block.id"
          class="title"
          v-if="block.content.level == 'h1'"
          v-html="block.content.text"
        />
        <h2
          :key="block.id"
          class="title"
          v-if="block.content.level == 'h2'"
          v-html="block.content.text"
        />
      </template>
      <div
        :key="block.id"
        class="text"
        v-if="block.type == 'text' || block.type == 'markdown'"
        v-html="block.content.text"
      />
      <hr :key="block.id" v-if="block.type == 'hr'" />
      <li :key="block.id" v-if="block.type == 'ul'" v-html="block.content" />
      <li :key="block.id" v-if="block.type == 'ol'" v-html="block.content" />
      <div
        class="code"
        :key="block.id"
        v-if="block.type == 'code'"
        v-html="block.content"
      />
      <div class="image" :key="block.id" v-if="block.type == 'imageg'">
        <img :src="block.content.src" :alt="block.attrs.caption" />
        <figcaption v-html="block.attrs.caption" />
      </div>
      <blockquote
        :key="block.id"
        v-if="block.type == 'quote'"
        v-html="block.content.text"
      />
      <div
        class="footnote"
        :id="'ftn' + block.content.number"
        :key="block.id"
        v-if="block.type == 'footnote'"
      >
        <sub @click="scrollTo(block.content.number)">{{
          block.content.number
        }}</sub>
        <div v-html="block.content.text"></div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    content: Array,
  },
  methods: {
    scrollTo(num) {
      let links = this.$refs.content.querySelectorAll("a");
      let filter = Array.from(links).filter((item) => {
        return item.hash.slice(4) == num;
      });
      filter[0].scrollIntoView();
      // console.log(num, links, filter[0]);
    },
  },
};
</script>

<style lang="scss">
.content {
  position: relative;
  a {
    border-bottom: 1px dotted black;
  }
  s {
    top: -0.2rem;
    position: relative;
    font-size: smaller;
    padding-left: 0.1rem;
    padding-right: 0.1rem;
    text-decoration: none;
  }
}
.footnote {
  display: flex;
  font-size: 0.8rem;
  line-height: 1.1;
  max-width: 65ch;
  sub {
    vertical-align: super;
    font-size: smaller;
    flex: 0 0 auto;
    cursor: pointer;
    width: calc(4 * var(--lh));
  }
  p {
    margin-bottom: 0;
  }
}
.footnote ~ .footnote p {
  margin-bottom: 0;
}
.footnote ~ .text {
  margin-top: var(--lh);
}
.footnote ~ .title {
  margin-top: calc(2 * var(--lh));
}
</style>
